window._rem = (function (_rem, w, d) {
  /* 
    Get $ and jQuery out of the global scope and hold it inside our remora object for internal use
    This is so third parties cannot override or ever change our jQuery.
    */
  _rem.jQuery = jQuery.noConflict(true);

  if (typeof _rem.store === 'undefined') {
    _rem.store = {
      files: [],
      callbacks: [],
      fileCallbacks: [],
      loaded: 0,
      retryCount: 0,
    };
  }

  _rem.const = {
    COOKIE_VEHICLE_VIEW: 'cookie_vehicle_view',
  };

  // Process things before the user navigates away from the current page
  window.onbeforeunload = function () {
    if (_rem.handleSrpView(false)) {
      dbg('Sent SRP Views synchronously');
    }
  };

  _rem.processTrdpAsyncFiles = function () {
    const fileCount = _rem.store.files.length;

    for (let i = 0; i < fileCount; i++) {
      const script = d.createElement('script');
      script.setAttribute('src', _rem.store.files[i]);

      if (script.readyState) {
        script.onreadystatechange = function () {
          if (this.readyState == 'loaded' || this.readyState == 'complete') {
            this.onreadystatechange = null;
            _rem.fileLoadedCallback();
          }
        };
      } else {
        script.onload = function () {
          _rem.fileLoadedCallback();
        };
      }

      d.body.appendChild(script);
    }

    if (fileCount == 0) {
      _rem.fileLoadedCallback();
    }
  };

  _rem.processReadyComplete = false;
  _rem.processReady = function () {
    if (_rem.store.callbacks.length) {
      _rem.jQuery('.js-load').fadeOut(250);
      _rem.jQuery('.js-load-hide').fadeIn(250);

      const callbacksLength = _rem.store.callbacks.length;

      for (let i = 0; i < callbacksLength; i++) {
        try {
          _rem.store.callbacks[i](_rem.jQuery);
        } catch (e) {
          console.error('Exception thrown by _rem.ready(). Caught to avoid errors on the page', e);
          if (typeof Sentry !== 'undefined') {
            Sentry.captureException(e);
          }
        }
      }

      _rem.store.callbacks = [];

      _rem.processReadyComplete = true;
    }

    // Once we're loaded, set _rem.ready() to just fire immediately
    _rem.ready = function (cb) {
      return cb(_rem.jQuery);
    };
  };

  _rem.fileLoadedCallback = function () {
    if (++_rem.store.loaded >= _rem.store.files.length) {
      const fileCallbacksLength = _rem.store.fileCallbacks.length;
      for (let i = 0; i < fileCallbacksLength; i++) {
        _rem.store.fileCallbacks[i](_rem.jQuery);
      }

      _rem.store.fileCallbacks = [];
      _rem.store.files = [];
    }
  };

  // jQuery .lazyload() is to be replaced with native JS IntersectionObserver for image swappoing without layout shift:
  _rem.initLazyLoad = function () {
    const lazyImages = document.querySelectorAll('img.lazy-load');
    if (!('IntersectionObserver' in window)) {
      console.log('IntersectionObserver not supported, using fallback');
      lazyImages.forEach((img) => {
        if (img.dataset.src) {
          console.log('Loading fallback:', img.dataset.src);
          img.src = img.dataset.src;
        }
      });
      return;
    }

    const imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            observer.unobserve(img);
          }
        });
      },
      { rootMargin: '200px' },
    );

    if (lazyImages.length === 0) {
      return;
    }

    lazyImages.forEach((img) => {
      imageObserver.observe(img);
    });
  };

  // Handle bfcache restore (browser back/forward navigation)
  window.addEventListener('pageshow', function (event) {
    // Reinitialize lazy load on every page display once DOM is ready
    setTimeout(function () {
      _rem.initLazyLoad();
    }, 100);
  });

  _rem.fileEnd = function () {
    _rem.jQuery.ajaxSetup({
      headers: { 'X-CSRF-TOKEN': _rem.jQuery('meta[name="csrf-token"]').attr('content') },
    });

    _rem.jQuery(d).ready(function () {
      _rem.processReady();

      _rem.srpImagesAndAnalytics(_rem.jQuery);
      _rem.headerAjaxEvents(_rem.jQuery);
      if (_rem.jQuery('body').hasClass('logged-in')) {
        _rem.replayAccountStorage();
      }
      _rem.formButtonsInit();
      _rem.initCouponShareButtons();

      // Initialize lazy loading intersection observer once DOM is ready
      _rem.initLazyLoad();

      _rem.initOverlayLauncherGuard();

      _rem.processTrdpAsyncFiles();
      _rem.finalInit(_rem.jQuery);
    });
  };

  _rem.openAccountSidebar = function () {
    _rem.jQuery('#acct-oc').sidebar('show');
  };

  // RE-1695: third-party chat launchers (Gubagoo et al.) pin themselves at
  // the 32-bit-max z-index, so they float over our takeover sidebars and can
  // cover critical actions (a form's submit button, on the field report).
  // While any Semantic UI sidebar is visible, body.rmr-overlay-open lets the
  // themed CSS hide the known launchers: their inline z-index !important is
  // unbeatable, but their `display` is inline WITHOUT !important, so a
  // stylesheet display:none !important wins. UserWay is deliberately never
  // hidden (accessibility).
  _rem.initOverlayLauncherGuard = function () {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    const sidebars = document.querySelectorAll('.ui.sidebar');
    if (!sidebars.length) {
      return;
    }
    const syncOverlayClass = function () {
      const anyVisible = document.querySelector('.ui.sidebar.visible') !== null;
      document.body.classList.toggle('rmr-overlay-open', anyVisible);
    };
    const observer = new MutationObserver(syncOverlayClass);
    sidebars.forEach(function (sidebar) {
      observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
    });
    syncOverlayClass();
  };

  _rem.replayAccountStorage = function () {
    const accountStorage = _rem.getCookie('accountStorage');

    if (!accountStorage) {
      return;
    }

    const accountDataObj = JSON.parse(accountStorage);

    if (accountDataObj.key === 'priceDropAlert') {
      const marked = _rem.jQuery(
        '[data-price-drop-alert="1"][data-cta-id="' +
          accountDataObj.ctaId +
          '"][data-vehicle-id="' +
          accountDataObj.vehicleId +
          '"]',
      );
      if (marked.length) {
        _rem.loadPriceDropAlertForm(marked.first());
      }
      _rem.removeCookie('accountStorage');
      return;
    }

    _rem
      .jQuery(
        '.veh-actions[data-vin="' +
          accountDataObj.vin +
          '"] *[data-key="' +
          accountDataObj.key +
          '"]:not(.active)',
      )
      .click();
    _rem.removeCookie('accountStorage');
  };

  _rem.headerAjaxEvents = function ($) {
    $('.ajax-api-cont').on('click', 'i.remove', function (event) {
      const clicked = $(this);
      const container = clicked.closest('.ajax-api-cont');
      container.parent().addClass('cursor-wait');
      const vin = clicked.data('vin');
      dbg('Remove icon clicked: ' + vin);

      _rem.ajax(
        {
          method: 'DELETE',
          url: container.data('url'),
          data: { vin: vin },
        },
        function (response) {
          dbg('Request to remove price drop alert for ' + vin + '. Response: ' + response.success);

          if (response.success) {
            clicked.closest('div.item').slideUp(400, function () {
              clicked.closest('div.item').remove();
            });

            const currentCount = parseInt($('#user-' + container.data('key') + '-count').text());
            const alertCount = currentCount - 1;
            $('#user-' + container.data('key') + '-count').text(alertCount);
            if (alertCount == 0) {
              container.find('.empty-msg').show();
              container.parent().find('.not-empty-msg').hide();
            }

            $('.veh-actions[data-vin="' + vin + '"]')
              .find('i[data-key="' + container.data('key') + '"]')
              .removeClass('active');
            // Sarasota Theme
            $('.veh-actions[data-vin="' + vin + '"]')
              .find('.action-item[data-key="' + container.data('key') + '"]')
              .removeClass('active');
          }

          container.parent().removeClass('cursor-wait');
        },
      );
    });

    // a.action-item is for Sarasota theme
    $('#inv-list, .detail-side').on(
      'click',
      'div.action-item > i.icon, .action-item',
      function (e) {
        e.preventDefault();

        if ($('body').hasClass('logged-out') && $(this).data('key') != 'comparedVehicles') {
          _rem.openAccountSidebar();

          _rem.setCookie(
            'accountStorage',
            JSON.stringify({
              key: $(this).data('key'),
              vin: $(this).closest('.veh-actions').data('vin'),
            }),
          );

          return false;
        }

        const newAlert = !$(this).hasClass('active');

        const url = $(this).data('url');
        const vin = $(this).closest('.veh-actions').data('vin');
        const container = $('#' + $(this).data('key') + '-item .ajax-api-cont');

        let currentCount = parseInt($('#user-' + $(this).data('key') + '-count').text());

        if ($(this).data('key') == 'comparedVehicles' && currentCount >= 8 && newAlert) {
          return alert('You can only compare up to 8 vehicles at a time');
        }

        $(this).toggleClass('active');
        $('#user-' + $(this).data('key') + '-count')
          .parent()
          .transition('tada');

        newAlert ? currentCount++ : currentCount--;
        $('#user-' + $(this).data('key') + '-count').text(currentCount);

        if (!newAlert) {
          container.find('div[data-vin="' + vin + '"]').remove();
        }

        _rem.ajax(
          {
            method: newAlert ? 'POST' : 'DELETE',
            url: url,
            data: { vin: vin },
          },
          function (response) {
            if (newAlert) {
              container.append(response.html);
              container.find('.empty-msg').hide();
              container.parent().find('.not-empty-msg').show();
            } else {
              container.find('div[data-vin="' + vin + '"]').remove();
              if (currentCount == 0) {
                container.find('.empty-msg').show();
                container.parent().find('.not-empty-msg').hide();
              }
            }
          },
        );
      },
    );

    $('#accountDropdown a.logout').on('click', function (e) {
      e.preventDefault();
      $('#accountDropdown').append(
        '<div class="ui inverted dimmer active"><div class="ui loader"></div></div>',
      );
      _rem.jQuery
        .ajax({
          url: $(this).attr('href'),
          method: 'GET',
        })
        .always(function (r) {
          $('body').removeClass('logged-in').addClass('logged-out');
          $('.veh-actions i.active, .veh-actions .action-item.active').removeClass('active');
          $('#accountDropdown div.ui.dimmer.active').remove();
        });
    });
  };

  _rem.srpViews = [];

  _rem.srpImagesAndAnalytics = function () {
    // Return if not on a list page
    const list = document.getElementById('inv-list');
    if (!list) return;

    // Record a single SRP impression for a list item, deduped per page session.
    // The first 3 items carry data-seen="1" in the markup (the server already
    // counted them via wasViewed('srp')), so they are skipped here to avoid a
    // double count. Ids are pushed as numbers so the dedup and the
    // integer-validated POST payload (TrackingController::postVehicles) agree.
    const recordView = (li) => {
      const id = li.getAttribute('data-id');
      if (!id || li.dataset.seen || _rem.srpViews.indexOf(+id) !== -1) return;
      _rem.srpViews.push(+id);
      li.dataset.seen = '1';
    };

    // Watch every list item directly instead of piggybacking on image
    // lazy-loading. The old jQuery lazyload 'appear' hook bound to 'img.lazy',
    // a class no longer emitted (images now use 'lazy-load'), so it counted
    // nothing below the server-side top 3. rootMargin mirrors the old 200px
    // threshold so an item counts just before it is fully on screen.
    //
    // This runs again after every AJAX filter/sort/pagination redraw
    // (list-javascript.blade.php replaces #inv-list then re-calls this), which
    // is how below-the-fold items on filtered/paged results get tracked.
    // Disconnect the previous observer first so it does not leak while holding
    // the now-detached <li> from the prior render.
    if (_rem.srpViewObserver) _rem.srpViewObserver.disconnect();

    if ('IntersectionObserver' in window) {
      _rem.srpViewObserver = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              recordView(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '200px' },
      );

      list.querySelectorAll('li[data-id]').forEach((li) => {
        if (!li.dataset.seen) _rem.srpViewObserver.observe(li);
      });
    } else {
      // No IntersectionObserver support: count every rendered item once.
      list.querySelectorAll('li[data-id]').forEach(recordView);
    }

    // Process the queue every second. Guarded so repeated invocations (one per
    // AJAX redraw) do not stack additional timers.
    if (!_rem.srpViewSender) {
      _rem.srpViewSender = setInterval(_rem.handleSrpView, 1000);
    }
  };

  _rem.handleSrpView = function (async) {
    // Return if there's no views to send at this time
    if (!_rem.srpViews.length) return false;

    if (async === null) async = true;

    dbg('Sent request for vehicle views. Count: ' + _rem.srpViews.length);

    _rem.ajax(
      {
        method: 'POST',
        url: '/ajax/tracking/vehicles',
        data: { ids: _rem.srpViews },
        async: async,
      },
      function (response) {
        dbg('Request to log vehicle views response: ' + response.success);
      },
    );

    _rem.srpViews = [];

    return true;
  };

  _rem.ajax = function (options, done) {
    return _rem.jQuery
      .ajax(options)
      .done(done)
      .error(function (error) {
        // Unauthorized response
        if (error.status == 401) {
          //window.location.href = '{{ route('login') }}?back=' + encodeURIComponent(window.location.href) + '&request=' + encodeURIComponent(options.url);
          _rem.openAccountSidebar();
        } else {
          dbg(error);
        }
      });
  };

  _rem.loadFormContent = function (url, button, type) {
    if (_rem.formOffCanvas == undefined) _rem.formOffCanvas = _rem.jQuery('#form-oc');
    if (!_rem.formOffCanvas) alert('We are unable to load the form at this time.');

    const vehicleId = button.data('vehicleId');
    url = url + (vehicleId ? '/' + vehicleId : '');

    button.parent().addClass('cursor-wait');

    _rem.jQuery('#formModalSendBtn').hide().removeClass('disabled');

    _rem.jQuery
      .ajax({
        method: 'GET',
        url: url,
      })
      .done(function (response) {
        let header = null;
        let content = response;

        //some special cases handled here based on form type
        if (['specialOffer', 'coupon'].indexOf(type) !== -1) {
          header = button.data('formTitle');
        } else if (type === 'agent') {
          header = 'Send ' + button.data('agentName') + ' A Message';
        } else if (type === 'review') {
          header = 'Please contact us with your review!';
        } else if (type === 'phone') {
          header = response.title || 'Send This Vehicle To My Phone';
          content = response.content;
        } else if (type === 'email') {
          header = 'Send To My Email';
        } else if (type === 'share') {
          header = 'Send This Vehicle To A Friend';
        } else if (type === 'incentivesRequestMoreInfo') {
          header = 'Request More Info';
        } else {
          header = response.title;
          content = response.content;
        }

        _rem.formOffCanvas.find('.js-content').html(content);

        // Update header while preserving the close button structure
        const headerHtml =
          '<h2 class="rmr_sidebar-header_heading">' +
          header +
          '</h2>' +
          '<i class="close icon" onclick="_rem.formOffCanvas.sidebar(\'toggle\');"></i>';

        _rem.formOffCanvas.find('.js-header').html(headerHtml);

        function addHiddenElement(name, value) {
          _rem
            .jQuery('<input>')
            .attr({
              type: 'hidden',
              value: value,
              name: name,
            })
            .appendTo(_rem.formOffCanvas.find('form'));
        }

        //Replace 'incentives.' with actual incentive
        if (type === 'incentivesRequestMoreInfo') {
          let offerType = button.data('offerType');
          //Remove trailing s, make singular
          if (offerType.lastIndexOf('s') == offerType.length - 1) {
            offerType = offerType.substr(0, offerType.length - 1);
          }

          //May not be attribute safe so not passed as button data
          const offerName = button
            .parentsUntil('div.ui.segment')
            .parent()
            .find('h3.offerName')
            .text()
            .trim();

          let textArea = _rem.formOffCanvas.context.querySelector('textArea').value;
          textArea = textArea.substring(0, textArea.length - 'incentives.'.length);

          textArea += offerType + ' - ' + offerName + '.';

          _rem.formOffCanvas.context.querySelector('textArea').value = textArea;
        }

        if (type === 'review') {
          _rem.formOffCanvas.sidebar('toggle');
          addHiddenElement('user_rating', parseInt(_rem.jQuery('#add-review-stars').val()));
        } else {
          _rem.formOffCanvas.sidebar('toggle');
          if (type === 'agent') {
            addHiddenElement('agentEmail', button.data('agentEmail'));
          } else if (type === 'specialOffer') {
            addHiddenElement('special_id', button.data('specialId'));
          }
          _rem.formOffCanvas.trigger('form-loaded');
        }
      })
      .fail(function (response) {
        //console.log( "FAIL form content response: %O", response );
      })
      .always(function () {
        button.parent().removeClass('cursor-wait');
      });
  };

  // Logged-out click and a 401 from the render request share this path.
  // The account sidebar's close abandons the intent. A sign-in link
  // navigates away without hiding the sidebar, so the cookie survives.
  const promptPriceDropSignIn = function (button) {
    _rem.setCookie(
      'accountStorage',
      JSON.stringify({
        key: 'priceDropAlert',
        ctaId: button.data('ctaId'),
        vehicleId: button.data('vehicleId'),
      }),
    );
    _rem.openAccountSidebar();
    _rem.jQuery('#acct-oc').sidebar('setting', 'onHidden', function () {
      _rem.removeCookie('accountStorage');
      _rem.jQuery('#acct-oc').sidebar('setting', 'onHidden', function () {});
    });
  };

  // Price-drop clicks do not share loadFormContent. A confirmed image still
  // receives the click, and a 401 sends the shopper to sign in.
  _rem.loadPriceDropAlertForm = function (button) {
    if (button.attr('aria-disabled') === 'true') {
      return;
    }

    if (_rem.formOffCanvas == undefined) _rem.formOffCanvas = _rem.jQuery('#form-oc');
    if (!_rem.formOffCanvas) alert('We are unable to load the form at this time.');

    const ctaId = button.data('ctaId');
    const vehicleId = button.data('vehicleId');
    let url = '/form-ajax-content/' + ctaId;
    if (vehicleId) {
      url = url + '/' + vehicleId;
    }

    button.parent().addClass('cursor-wait');

    _rem.jQuery('#formModalSendBtn').hide().removeClass('disabled');

    _rem.jQuery
      .ajax({
        method: 'GET',
        url: url,
      })
      .done(function (response) {
        const header = response.title;
        const content = response.content;

        _rem.formOffCanvas.find('.js-content').html(content);

        const headerHtml =
          '<h2 class="rmr_sidebar-header_heading">' +
          header +
          '</h2>' +
          '<i class="close icon" onclick="_rem.formOffCanvas.sidebar(\'toggle\');"></i>';

        _rem.formOffCanvas.find('.js-header').html(headerHtml);
        _rem.formOffCanvas.sidebar('toggle');
        _rem.formOffCanvas.trigger('form-loaded');
      })
      .fail(function (response) {
        if (response.status === 401) {
          // Rendered logged-in, so the account sidebar still shows favorites.
          // The session is gone; the body class is stale.
          _rem.jQuery('body').removeClass('logged-in').addClass('logged-out');
          promptPriceDropSignIn(button);
        }
      })
      .always(function () {
        button.parent().removeClass('cursor-wait');
      });
  };

  _rem.formButtonsInit = function () {
    _rem.jQuery('[data-oc-form-id]').click(function () {
      const button = _rem.jQuery(this);
      if (button.attr('data-price-drop-alert') === '1') {
        if (_rem.jQuery('body').hasClass('logged-out')) {
          promptPriceDropSignIn(button);
          return;
        }
        _rem.loadPriceDropAlertForm(button);
        return;
      }
      const formId = button.data('ocFormId');
      const url = '/form-content/' + formId;

      _rem.loadFormContent(url, button);
    });
  };

  // One document-level listener serves every coupon share button, however and
  // whenever the coupon markup reaches the page.
  _rem.initCouponShareButtons = function () {
    _rem.jQuery(d).on('click', '.coupon-share-button', function (e) {
      e.preventDefault();
      const button = _rem.jQuery(this);
      _rem.loadFormContent(
        '/form-content/' + button.data('formType') + '/' + button.data('couponId'),
        button,
        'coupon',
      );
    });
  };

  _rem.RemoraForm = function (config) {
    //const
    this.MIN_STEP_HEIGHT = config.stepHeight ? config.stepHeight : 450;
    this.FORM_DIV_SUFFIX = config.divSuffix ? config.divSuffix : '_div_';

    this.$ = config.jquery;
    this.formName = config.formName;
    this.formId = config.formId;
    this.multiStep = config.multiStep ? config.multiStep : false;
    this.stepCount = config.stepCount ? config.stepCount : 0;
    this.validationObj = config.validationObj;
    this.messageContainerId = config.messageContainerId;
    this.submitURL = config.submitURL ? config.submitURL : '/form-submission';
    //submitText is currently only referenced for forms with multiple steps, single step has this set when its html is constructed
    this.submitText = config.submitText ? config.submitText : 'Send Now';
    this.uniqueId = config.uniqueId;
    this.onSuccess = typeof config.onSuccess === 'function' ? config.onSuccess : null;
  };

  // Post-submit page state for a price-drop signup. The favorites helpers are
  // called with no existence guard: a missing helper is a defect, not a quiet
  // no-op. The vehicle's own list row is checked first, because the heart's
  // add can land before this response and would otherwise be duplicated.
  _rem.priceDropAlertSucceeded = function (response, vehicleId) {
    const vehicleKey = String(vehicleId);
    const marked = document.querySelectorAll(
      '[data-price-drop-alert="1"][data-vehicle-id="' + vehicleKey + '"]',
    );

    marked.forEach(function (el) {
      if (el.tagName === 'BUTTON') {
        el.disabled = true;
        el.setAttribute('aria-disabled', 'true');
        const check = document.createElement('i');
        check.className = 'check icon';
        const existingIcon = el.querySelector('i');
        if (existingIcon) {
          existingIcon.replaceWith(check);
        } else {
          el.insertBefore(check, el.firstChild);
        }
      } else if (el.tagName === 'IMG') {
        el.setAttribute('aria-disabled', 'true');
        el.style.cursor = 'default';
        el.style.opacity = '0.5';
      }
    });

    document
      .querySelectorAll('span[data-key="fav"][data-vehicle-id="' + vehicleKey + '"]')
      .forEach(function (heart) {
        heart.classList.add('selected');
      });

    if (response && response.newlySaved === true) {
      // The heart can land its row while this signup is still in flight.
      // An already-listed vehicle gets none of the three favorites calls.
      const existingRow = document.querySelector(
        '#user-favorite-list [data-vehicle-id="' + vehicleKey + '"]',
      );
      if (!existingRow) {
        addUserFavVehicleRow(response.savedVehicle);
        _rem.userFavCount++;
        updateUserFavCount();
      }
    }
  };

  _rem.RemoraForm.prototype.scrollToFormTop = function () {
    const $ = this.$;
    const pthis = this;

    setTimeout(function () {
      //forms in modal
      if ($('.ui.modals.page.visible.active').length > 0) {
        $('.ui.modals.page.visible.active').animate(
          {
            scrollTop: 0,
          },
          100,
        );
      }
      //non modal
      else {
        $('html, body').animate(
          {
            scrollTop: $('#' + pthis.formName).offset().top - 80,
          },
          100,
        );
      }

      $('.ui.sticky').sticky('refresh');
    }, 50);
  };

  _rem.RemoraForm.prototype.initMultiStep = function () {
    //console.log("init multiStep : " + this.formName);
    const pthis = this;
    const $ = this.$;
    $('#btnFormSubmit_' + pthis.formName).remove();

    const onLoadHandler = function ($, formName, pthis) {
      function resizeJquerySteps() {
        let h = $('#' + pthis.formName + ' > .wizard > .content > .body.current').outerHeight();
        h = h > pthis.MIN_STEP_HEIGHT ? h : pthis.MIN_STEP_HEIGHT;
        $('#' + pthis.formName + ' > .wizard > .content').height(h);
      }
      $(window).on('resize', function () {
        resizeJquerySteps();
      });

      const _formWiz = $('#' + pthis.formName);
      _formWiz.children('div').steps({
        labels: {
          finish: pthis.submitText,
        },

        headerTag: 'h3',
        bodyTag: 'section',
        transitionEffect: 'fade',

        onStepChanging: function (event, currentIndex, newIndex) {
          if (newIndex < currentIndex) {
            //this means the user is going to the previous step and we dont want to validate
            return true;
          }
          const formString = '#' + pthis.formName + pthis.FORM_DIV_SUFFIX + currentIndex.toString();
          //console.log("onstepchanging : "+formString);
          const valid = $(formString).form('validate form');
          resizeJquerySteps();
          if (!valid) {
            pthis.scrollToFormTop();
          } else {
            let formName = 'Form';

            try {
              if (_rem.formOffCanvas && _rem.formOffCanvas.length > 0) {
                const headerText = _rem.formOffCanvas
                  .find('.rmr_sidebar-header_heading')
                  .text()
                  .trim();
                if (headerText) {
                  formName = headerText;
                }
              }
            } catch (e) {}

            if (formName === 'Form') {
              try {
                // Attempt 2: Try to get from form's h2
                const h2Text = $('#' + pthis.formName)
                  .closest('form')
                  .find('h2')
                  .first()
                  .text()
                  .trim();
                if (h2Text) {
                  formName = h2Text;
                }
              } catch (e) {}
            }

            _rem.ascEvent('asc_form_engagement', {
              comm_status: 'engage',
              element_text: 'Step ' + (currentIndex + 1) + ' Complete',
              form_name: formName,
              department: 'sales',
              form_type: 'consumer_contact',
            });
          }
          return valid;
        },

        onStepChanged: function (event, currentIndex, priorIndex) {
          resizeJquerySteps();
        },

        onInit: function (event, currentIndex) {
          //console.log('steps onINit');
          const _formId = '#' + pthis.formName;

          //init all step forms
          for (let i = 0; i < pthis.stepCount; i++) {
            const formString = _formId + pthis.FORM_DIV_SUFFIX + i.toString();
            //console.log("onInit : %O %O", formString, pthis.validationObj);
            $(formString).form(pthis.validationObj);
          }

          //dropdowns
          $(_formId + ' .ui.normal.dropdown').dropdown({});

          //icon tooltip/popups
          $(_formId + ' .icon.link').popup({});

          //checkbox
          $(_formId + ' .ui.checkbox').checkbox();
          pthis.initCheckBox($);

          //calendar
          $(_formId + ' .ui.calendar').calendar({ type: 'date' });
          $(_formId + ' .ui.calendar.datetime').calendar();

          resizeJquerySteps();
        },

        onFinished: function (event, currentIndex) {
          resizeJquerySteps();

          if (
            $('#' + pthis.formName + pthis.FORM_DIV_SUFFIX + currentIndex.toString()).form(
              'validate form',
            )
          ) {
            //console.log("form is valid, COMPLETE");
            const btnFinish = _formWiz.find(".actions a[href$='#finish']").parent();
            btnFinish.addClass('disabled');
            _rem.jQuery('#formModalSendBtn').addClass('disabled');

            // RE-2451 (A1): an eligible lead wizard finishes through a real submit
            // event, so a declarative tool invocation can observe it. form.onsubmit
            // calls submitForm for the Finish-started submit only. Native validation
            // is off for that one call: the steps were validated as they were left, and
            // a field on a hidden step could otherwise block it without a word.
            const wizardForm = document.getElementById(pthis.formName);
            if (
              wizardForm &&
              wizardForm.querySelector('[data-lead-submit]') &&
              typeof wizardForm.requestSubmit === 'function'
            ) {
              const wasNoValidate = wizardForm.noValidate;
              wizardForm.noValidate = true;
              wizardForm.setAttribute('data-lead-finishing', '');
              try {
                wizardForm.requestSubmit();
              } finally {
                wizardForm.removeAttribute('data-lead-finishing');
                wizardForm.noValidate = wasNoValidate;
              }
            } else {
              pthis.submitForm(
                pthis.formName,
                $,
                pthis.messageContainerId,
                pthis.formId,
                pthis.submitURL,
                true,
                undefined,
                pthis.onSuccess,
              );
            }
          } else {
            //console.log("form invalid, FAILURE");
            //window.scrollTo(0,0);
            pthis.scrollToFormTop();

            resizeJquerySteps();
            _rem.dispatchFormResult(pthis.formName, 'validation_failed');
          }
        },
      });
    };

    onLoadHandler($, pthis.formName, pthis);
  };

  _rem.RemoraForm.prototype.initBasic = function () {
    const form = _rem.jQuery('#' + this.formName);
    //init global components
    form.form(this.validationObj);
    form.find('.ui.normal.dropdown').dropdown({});
    form.find('.icon.link').popup({});
    form.find('.ui.calendar').calendar({ type: 'date' });
    form.find('.ui.calendar.datetime').calendar();
    this.initCheckBox(_rem.jQuery);
  };

  _rem.RemoraForm.prototype.init = function () {
    const pthis = this;
    const $ = this.$;

    _rem.ensureRecaptcha();

    const formName = this.formName;
    const messageContainerId = this.messageContainerId;
    const form = document.getElementById(this.formName);
    const submitForm = this.submitForm;
    const formId = this.formId;
    const submitURL = this.submitURL;
    const uniqueId = this.uniqueId;
    const onSuccess = this.onSuccess;

    //on submit handler
    form.onsubmit = function (event) {
      //console.log('form.onsubmit %O', event);
      event.preventDefault();
      // RE-2451 (A1): an eligible lead wizard carries a hidden submit button so a
      // declarative tool can run. A submit it raises on its own (Enter in a field) must
      // not post a partial wizard: only Finish on the last step, which has already
      // validated, sends it. Other wizards have no such button and are untouched.
      if (form.querySelector('[data-lead-submit]')) {
        if (!form.hasAttribute('data-lead-finishing')) {
          // An agent-invoked submit that is not Finish is answered, never left pending.
          if (event.agentInvoked) {
            _rem.dispatchFormResult(formName, 'validation_failed');
          }

          return false;
        }
        submitForm(formName, $, messageContainerId, formId, submitURL, true, undefined, onSuccess);

        return true;
      }
      const valid = $('#' + formName).form('validate form');
      //console.log("form valid: "+valid);
      if (valid) {
        $('#formModalSendBtn, #btnFormSubmit_' + formName).addClass('disabled');

        submitForm(
          formName,
          $,
          messageContainerId,
          formId,
          submitURL,
          undefined,
          undefined,
          onSuccess,
        );

        return true;
      } else {
        //window.scrollTo(0,0);
        pthis.scrollToFormTop();
        _rem.dispatchFormResult(formName, 'validation_failed');
      }
      return false;
    };

    //init validation
    this.initValidationRules();

    //init form after the current event loop is complete (setTimeout 0)
    setTimeout(
      function () {
        this.multiStep ? this.initMultiStep() : this.initBasic();
      }.bind(this),
      0,
    );
  };

  _rem.RemoraForm.prototype.initValidationRules = function () {
    const $ = this.$;
    $.fn.form.settings.rules.checkboxGroupRequired = function (value, param) {
      //console.log("checkboxGroupRequired %O %O", value, param);
      const params = param.split(',');
      const fieldName = params[0];
      const formName = params[1];
      const form = $('#' + formName);
      const listGroup = form.find('#' + fieldName + '_list');
      const checkbox = listGroup.find('.checkbox');
      let checked = false;

      checkbox.each(function () {
        if ($(this).checkbox('is checked')) {
          checked = true;
        }
      });

      return checked;
    };

    $.fn.form.settings.rules.creditCardInfo = function (value, fieldName) {
      const ccid = $('#' + fieldName + '_ccid');
      const expire = $('#' + fieldName + '_expire');
      const ccidValid = ccid.val() || false;
      const expireValid = expire.val() || false;
      return ccidValid && expireValid;
    };

    // Custom phone validation: strips non-numeric chars (except leading +) and validates 7-17 digits
    $.fn.form.settings.rules.phoneNumber = function (value) {
      if (!value || typeof value !== 'string') {
        return false;
      }

      // Check if value starts with +
      const hasLeadingPlus = value.trim().charAt(0) === '+';

      // Strip all non-numeric characters
      const digitsOnly = value.replace(/\D/g, '');

      // Check if we have 7-17 digits
      const digitCount = digitsOnly.length;
      return digitCount >= 7 && digitCount <= 17;
    };
  };

  // RE-2451: a form announces how its submission ended with one `remora:form-result`
  // CustomEvent on the form element. The detail is only {outcome}, one of accepted,
  // validation_failed, spam_rejected, failed or unknown (the response was lost after
  // the request was sent). Never a field, a response body or a routing value, and
  // nothing here retries or changes what the shopper sees. The WebMCP lead registry
  // (agentic-tools.js) resolves an agent-invoked submit from it.
  _rem.dispatchFormResult = function (formName, outcome) {
    try {
      const form = document.getElementById(formName);
      if (form) {
        form.dispatchEvent(
          new CustomEvent('remora:form-result', { bubbles: true, detail: { outcome: outcome } }),
        );
      }
    } catch (e) {}
  };

  // `data` is what jQuery's always() hands over: the response body on success, the
  // jqXHR on failure. Status 0 means no response arrived, so the request may or may
  // not have been delivered: unknown, never a claim of failure.
  _rem.formResultOutcome = function (data, accepted) {
    if (accepted) {
      return 'accepted';
    }
    const status = data ? data.status : undefined;
    if (status === 422) {
      const errors = data.responseJSON ? data.responseJSON.errors : undefined;

      return errors && typeof errors === 'object' && errors.response !== undefined
        ? 'spam_rejected'
        : 'validation_failed';
    }

    return status === 0 ? 'unknown' : 'failed';
  };

  _rem.RemoraForm.prototype.submitForm = function (
    fName,
    $,
    messageContainerId,
    formId,
    submitURL,
    multiStep,
    gcToken,
    onSuccess,
  ) {
    const successCallback = typeof onSuccess === 'function' ? onSuccess : null;

    // A third-party widget's reCAPTCHA Enterprise object can own
    // window.grecaptcha without a top-level ready()/execute() (RE-1692);
    // only run the token flow when the standard v3 API is actually present,
    // otherwise fall through and submit without a token.
    if (
      window.grecaptcha &&
      typeof grecaptcha.ready === 'function' &&
      typeof grecaptcha.execute === 'function' &&
      _rem.gcSiteKey &&
      typeof gcToken === 'undefined'
    ) {
      grecaptcha.ready(function () {
        grecaptcha.execute(_rem.gcSiteKey, { action: 'submit' }).then(
          function (token) {
            _rem.RemoraForm.prototype.submitForm(
              fName,
              $,
              messageContainerId,
              formId,
              submitURL,
              multiStep,
              token,
              successCallback,
            );
          },
          function () {
            // No token, so no request was sent.
            _rem.dispatchFormResult(fName, 'failed');
          },
        );
      });
      return false;
    }
    gcToken = gcToken ? gcToken : '';

    $('#' + fName)
      .parent()
      .addClass('cursor-wait');

    //add page url to the form
    $('#' + fName).append(
      '<input type="hidden" name="pageUrl" value="' + window.location.href + '" />',
    );

    let postParams = {};
    // get ga client id (parse _ga cookie; works for GA4 + UA, no tracker-init race)
    // RE-1603 (CIPA Phase 6) — while tracking is denied there is no _ga parse
    // and no ga_client_id append (the server drops it regardless; Phase 5).
    const gaPermitted = _rem.trackingPermitted();
    let gaClientId = '';
    if (gaPermitted) {
      const gaMatch = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/);
      if (gaMatch) {
        gaClientId = gaMatch[1];
      } else if (typeof ga !== 'undefined' && typeof ga.getAll !== 'undefined') {
        const trackers = ga.getAll();
        if (typeof trackers[0] !== 'undefined') {
          gaClientId = trackers[0].get('clientId');
        }
      }
    }

    //if file field is present then use FormData to build the data object, otherwise get a serialized array of the form data
    if ($('#' + fName).find("input[type='file']").length > 0) {
      //FormData object that will include file fields in the ajax upload
      postParams = {
        url: submitURL,
        data: new FormData(document.getElementById(fName)),
        cache: false,
        contentType: false,
        processData: false,
      };
      if (gaPermitted) {
        postParams.data.append('ga_client_id', gaClientId);
      }
      postParams.data.append('gc_token', gcToken);
    } else {
      postParams = {
        url: submitURL,
        data: $('#' + fName).serialize(),
      };
      if (gaPermitted) {
        postParams.data += '&ga_client_id=' + gaClientId;
      }
      postParams.data += '&gc_token=' + gcToken;
    }

    $.post(postParams)
      .error(function (e) {
        if (e.status === 422) {
          // IE10 bugfix/hack
          if (typeof e.responseJSON === 'undefined') {
            e.responseJSON = e;
          }

          if (e.responseJSON && e.responseJSON['errors']) {
            const errors = e.responseJSON['errors'];
            let errorMessage = "<div class='ui error message'><ui class='list'>";
            for (const error in errors) {
              errorMessage += '<li>' + errors[error] + '</li>';
            }
            errorMessage += '</ui></div>';
            $('#' + messageContainerId).html(errorMessage);
          }
        } else {
          displayDefaultErrorMessage();
        }
        enableSubmit();
      })
      .always(function (data) {
        // IE10 bugfix/hack
        if (typeof data.responseJSON === 'undefined') {
          data.responseJSON = data;
        }

        $('#' + fName)
          .parent()
          .removeClass('cursor-wait');

        let accepted = false;
        if (
          data.responseJSON &&
          (data.responseJSON['successMessage'] || data.responseJSON['successRedirect'])
        ) {
          accepted = true;
          if (data.responseJSON['formTitle']) {
            _rem.gaEvent('Forms', 'Submit', data.responseJSON['formTitle']);
            _rem.ascEvent('asc_form_submission', {
              element_text: '',
              form_name: data.responseJSON['formTitle'],
              submission_id: data.responseJSON['form_submission_id'],
              form_type: data.responseJSON['form_type'],
              department: data.responseJSON['form_department'],
            });
            if (data.responseJSON['form_department'] == 'sales') {
              _rem.ascEvent('asc_form_submission_sales', {
                element_text: '',
                form_name: data.responseJSON['formTitle'],
                submission_id: data.responseJSON['form_submission_id'],
                form_type: data.responseJSON['form_type'],
                department: data.responseJSON['form_department'],
              });
            } else {
              _rem.ascEvent('asc_form_submission_other', {
                element_text: '',
                form_name: data.responseJSON['formTitle'],
                submission_id: data.responseJSON['form_submission_id'],
                form_type: data.responseJSON['form_type'],
                department: data.responseJSON['form_department'],
              });
            }
            if (data.responseJSON['purchase_intent']) {
              _rem.ascEvent('asc_retail_process', {
                flow_name: data.responseJSON['form_type'],
                element_title: data.responseJSON['formTitle'],
                flow_outcome: 'added',
                flow_stage: data.responseJSON['form_submission_id'],
              });
            }
          }

          if (data.responseJSON['successMessage']) {
            $('#' + messageContainerId).html(
              "<div class='ui ignored confirm message'>" +
                data.responseJSON['successMessage'] +
                '</div>',
            );
            //Hide the form after a successful
            $('#formModalSendBtn, #' + fName).hide();

            //trackingPixelSubmit should only be appended when the response does not include a redirect
            if (data.responseJSON['trackingPixelSubmit']) {
              $('#' + messageContainerId).append(data.responseJSON['trackingPixelSubmit']);
            }

            // After the confirmation is on the page, so a throwing callback
            // cannot hide a lead that already saved.
            if (typeof successCallback === 'function') {
              successCallback(data.responseJSON);
            }
          } else if (data.responseJSON['successRedirect']) {
            if (typeof successCallback === 'function') {
              // The lead already saved and the shopper is owed the submit page,
              // so a throwing callback must not strand them on the form.
              try {
                successCallback(data.responseJSON);
              } catch (e) {
                console.error('Exception thrown by a form onSuccess callback before a redirect', e);
                if (typeof Sentry !== 'undefined') {
                  Sentry.captureException(e);
                }
              }
            }
            window.location.href = data.responseJSON['successRedirect'];
          }
        }
        //422 is handled in error() so all other problems are handled here with default error message
        else if (data.status !== 422) {
          //data doesnt have any valid properties , this can happen when theres a problem but the server still sends 200
          displayDefaultErrorMessage();
          enableSubmit();
        }

        _rem.dispatchFormResult(fName, _rem.formResultOutcome(data, accepted));
      });

    //updates the view to show a default error message, nested to this prototype method because its only called here
    const displayDefaultErrorMessage = function () {
      $('#' + messageContainerId).html(
        "<div class='ui error message'><ui class='list'><li>There was a problem sending your request. Please try again later.</li></ui></div>",
      );
    };

    const enableSubmit = function () {
      if (multiStep) {
        $('#' + fName)
          .find('a[href="#finish"]')
          .parent()
          .removeClass('disabled');
        $('#formModalSendBtn').removeClass('disabled');
      } else {
        $('#formModalSendBtn, #btnFormSubmit_' + fName).removeClass('disabled');
      }
    };
  };

  _rem.RemoraForm.prototype.initCheckBox = function ($) {
    const formName = this.formName;
    $('#' + formName + ' .ui.master.checkbox').checkbox({
      // check all children
      onChecked: function () {
        const childCheckbox = $(this).closest('.checkbox').siblings('.list').find('.checkbox');
        childCheckbox.checkbox('check');
      },
      // uncheck all children
      onUnchecked: function () {
        const childCheckbox = $(this).closest('.checkbox').siblings('.list').find('.checkbox');
        childCheckbox.checkbox('uncheck');
      },
    });

    $('#' + formName + ' .list .child.checkbox').checkbox({
      // Fire on load to set parent value
      fireOnInit: true,
      // Change parent state on each child checkbox change
      onChange: function () {
        const listGroup = $(this).closest('.list');
        const parentCheckbox = listGroup.closest('.item').children('.checkbox');
        const checkbox = listGroup.find('.checkbox');
        let allChecked = true;
        let allUnchecked = true;

        // check to see if all other siblings are checked or unchecked
        checkbox.each(function () {
          if ($(this).checkbox('is checked')) {
            allUnchecked = false;
          } else {
            allChecked = false;
          }
        });
        // set parent checkbox state, but dont trigger its onChange callback
        if (allChecked) {
          parentCheckbox.checkbox('set checked');
        } else if (allUnchecked) {
          parentCheckbox.checkbox('set unchecked');
        } else {
          parentCheckbox.checkbox('set indeterminate');
        }
      },
    });
  };

  _rem.createObjFromURI = function (uri) {
    const chunks = uri.replace('#', '').split('&');
    const params = Object();
    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i].split('=');
      if (chunk[0] && chunk[0].search('\\[\\]') !== -1) {
        //remove [] from keys
        chunk[0] = chunk[0].replace(/\[\]$/, '');
        //create new index or add to existing
        if (typeof params[chunk[0]] === 'undefined') {
          if (chunk[1]) params[chunk[0]] = [chunk[1]];
        } else {
          if (chunk[1]) params[chunk[0]].push(chunk[1]);
        }
      } else if (chunk && chunk[0] && chunk[1]) {
        params[chunk[0]] = chunk[1];
      }
    }
    return params;
  };

  _rem.googleMaps = [];
  _rem.googleApiKey = null;
  _rem.initializeMap = function (mapObj) {
    if (!_rem.googleApiKey) {
      _rem.googleApiKey = mapObj.googleApiKey;
    }
    _rem.googleMaps.push(mapObj);
  };

  _rem.googleMapsLoaded = function () {
    _rem.googleMaps.forEach(function (mapObj) {
      _rem.createMapFromObject(mapObj);
    });
  };

  _rem.createMapFromObject = function (mapObj) {
    const map_options = {
      zoom: Number(mapObj.zoom_level),
      center: new google.maps.LatLng(mapObj.centerLat, mapObj.centerLng),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        mapTypeIds: ['aerial', google.maps.MapTypeId.ROADMAP],
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
      },
      zoomControl: true,
    };
    let my_map = null;
    const drawing_instance = {
      markers: [],
      initialize: function () {
        const self = this;
        my_map = new google.maps.Map(
          document.getElementById('map-canvas-' + mapObj.mapId),
          map_options,
        );
        mapObj.locations.forEach(function (location) {
          self.create_marker(
            location.lat,
            location.lng,
            '<b>' + location.name + '</b><br />' + location.address + '<br />' + location.address2,
            location.img_path,
          );
        });
      },
      infoWindow: function (_marker, _content) {
        const infowindow = new google.maps.InfoWindow({
          content: _content,
        });
        google.maps.event.addListener(_marker, 'mouseup', function () {
          infowindow.open(my_map, _marker);
        });
      },
      create_marker: function (_lat, _lng, _content, _icon) {
        const markerOptions = {
          position: { lat: _lat, lng: _lng },
          map: my_map,
        };
        // Only add icon if it exists and is a valid URL
        if (_icon && _icon.trim() !== '') {
          markerOptions.icon = {
            url: _icon,
            scaledSize: new google.maps.Size(25, 25),
          };
        }
        const marker_ = new google.maps.Marker(markerOptions);
        this.infoWindow(marker_, _content);
      },
    };

    drawing_instance.initialize();
  };

  let googleMapLoading = false;
  _rem.loadGoogleMaps = function () {
    if (!googleMapLoading && _rem.googleMaps.length > 0) {
      if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        const gmapsScript = document.createElement('script');
        gmapsScript.setAttribute(
          'src',
          'https://maps.googleapis.com/maps/api/js?key=' +
            _rem.googleApiKey +
            '&callback=_rem.googleMapsLoaded&loading=async',
        );
        gmapsScript.setAttribute('type', 'text/javascript');
        gmapsScript.setAttribute('async', 'async');
        document.getElementsByTagName('script')[0].parentNode.appendChild(gmapsScript);
        googleMapLoading = true;
      }
    }
  };

  // Enhanced Payment Calculator unified CTA button click handler
  _rem.handleEnhancedPaymentsButtonClick = function (button, isValueYourTrade) {
    // Prefer button data-vehicle if present, fallback to global currentVehicle (for VDP)
    const buttonVehicle = button.getAttribute('data-vehicle');
    const vehicleData = buttonVehicle
      ? JSON.parse(buttonVehicle)
      : window._rem.currentVehicle || {};
    const buttonLabel = button.textContent.replace(/\s+/g, ' ').trim();
    const defaultLabel = isValueYourTrade ? 'Value Your Trade' : 'Calculate Your Payment';

    // Determine calculator type based on context
    const calculatorType = isValueYourTrade
      ? 'trade'
      : vehicleData && vehicleData.vehicle_id
        ? 'payment'
        : 'buying-power';

    // Fire analytics events
    _rem.gaEvent('button', 'click', `cta ${(buttonLabel || defaultLabel).toLowerCase()}`);

    _rem.ascEvent('asc_cta_interaction', {
      element_type: 'button',
      element_subtype: 'cta_button',
      element_text: buttonLabel || defaultLabel,
      event_action: 'click',
      form_name:
        calculatorType === 'trade'
          ? 'Value Your Trade'
          : calculatorType === 'payment'
            ? 'Calculate Your Payment'
            : 'Calculate Your Buying Power',
      form_type: 'quote',
      department: isValueYourTrade ? 'trade' : 'sales',
      event_owner: 'remora',
      product_name: 'Remora',
    });
    // Note: page_type is populated from body element's attribute asc-page-type

    // Lazy-load payment calculator widget
    if (_rem.loadPaymentCalculator) {
      _rem.loadPaymentCalculator(calculatorType, vehicleData);
    } else {
      console.warn('Enhanced Payment Calculator widget not initialized');
    }
  };

  return _rem;
})(window._rem || {}, window, document);

function dbg(output) {
  return (
    window.location.href.indexOf('remoradev.com') && console && console.log && console.log(output)
  );
}

function smpopup(url) {
  const hwnd = window.open(url, 'name', 'height=400,width=600');

  if (window.focus) {
    hwnd.focus();
  }

  return false;
}

// Accessibility shim around the barrating star-rating plugin (RE-1633).
//
// barrating renders each star as an empty <a href="#">, which fails two PSI
// accessibility audits: the links have no discernible name, and stars inside
// aria-hidden carousel slides stay focusable (barrating injects its anchors
// after slick's init-time ADA pass has already neutralized hidden-slide
// focusables). Wrapping $.fn.barrating covers every init site without
// per-view edits:
//
// - readonly widgets: every anchor is replaced with a span carrying the same
//   classes (so rater.css styling is unchanged) and the widget exposes
//   role="img" with a "Rated N out of 5 stars" label. Nothing focusable
//   remains for slick's ADA passes to manage.
// - interactive widgets (the add-review input): anchors stay clickable and
//   each gains an accessible name ("1 star" ... "5 stars").
(function ($) {
  // Guarded because the unit-test harness loads this bundle without the
  // vendor plugin; the script loaders always load rater.js before remora.
  if (!$ || typeof $.fn.barrating !== 'function') {
    return;
  }

  const vendorBarrating = $.fn.barrating;

  $.fn.barrating = function (options) {
    const vendorResult = vendorBarrating.apply(this, arguments);

    // Method calls ('show', 'destroy', ...) pass through untouched.
    if (typeof options === 'string') {
      return vendorResult;
    }

    this.each(function () {
      const $select = $(this);
      const $widget = $select.closest('.br-wrapper').find('.br-widget');

      if (!$widget.length) {
        return;
      }

      if ($widget.hasClass('br-readonly')) {
        const $anchors = $widget.find('a');
        // barrating resolved the rating during init and stored it on the
        // select; read that state rather than re-deriving it from the DOM.
        const vendorState = $select.data('barrating') || {};
        const rating = parseInt(vendorState.ratingValue, 10) || 0;

        $anchors.each(function () {
          const $anchor = $(this);
          $anchor.replaceWith($('<span></span>').attr('class', $anchor.attr('class') || ''));
        });

        $widget.attr({
          role: 'img',
          'aria-label': `Rated ${rating} out of ${$anchors.length} stars`,
        });
      } else {
        $widget.find('a').each(function () {
          const ratingValue = $(this).attr('data-rating-value');
          $(this).attr('aria-label', ratingValue === '1' ? '1 star' : `${ratingValue} stars`);
        });
      }
    });

    return vendorResult;
  };
})(_rem.jQuery);

// Gallery scroll milestone tracking — pure helper, exposed for testing (RE-1347).
//
// Each call returns the asc_media_interaction events that should fire for the
// current scroll position, plus the new milestone state. Only one event is
// emitted per crossed milestone; event_action_result distinguishes them
// ("started" / "progress" / "complete") so consumers never see two pushes
// with identical name + payload from a single user action.
_rem.gallery = {
  computeScrollEvents: function (state, scrollTop, scrollHeight, clientHeight, linkUrl) {
    const events = [];
    const newState = {
      scrollFired: !!state.scrollFired,
      fiftyPercentFired: !!state.fiftyPercentFired,
      hundredPercentFired: !!state.hundredPercentFired,
    };

    const maxScroll = scrollHeight - clientHeight;
    const scrollPercentage = maxScroll <= 0 ? 0 : (scrollTop / maxScroll) * 100;

    function build(result) {
      return {
        name: 'asc_media_interaction',
        params: {
          page_type: 'item',
          event_action: 'scroll',
          event_action_result: result,
          media_type: 'gallery',
          link_url: linkUrl,
          product_name: 'Remora',
        },
      };
    }

    if (!newState.scrollFired && scrollTop > 0) {
      events.push(build('started'));
      newState.scrollFired = true;
    }

    if (!newState.fiftyPercentFired && scrollPercentage >= 50) {
      events.push(build('progress'));
      newState.fiftyPercentFired = true;
    }

    if (!newState.hundredPercentFired && scrollPercentage >= 100) {
      events.push(build('complete'));
      newState.hundredPercentFired = true;
    }

    return { events: events, newState: newState };
  },
};

//TODO: bake unshift into rem.ready
//_rem.ready(function ($) {
//_rem.store.callbacks.unshift(function($) {
_rem.finalInit = function ($) {
  $('.ui.accordion').accordion();
  $('.ui.radio.checkbox').checkbox();
  $('.ui.modal.review-full').modal('attach events', '.review-trigger', 'show');
  $('#user-search').modal({ closable: false }).modal('attach events', '.search.trigger', 'show');

  $('.ui.menu a.item').on('click', function () {
    $(this).addClass('active').siblings().removeClass('active');
  });

  // Menu interaction tracking for desktop navigation
  $('body').on('click', '.nav-menu .menu-link', function () {
    const menuText = $(this).text().trim();
    const menuSubtype = $(this).closest('.menu-item').hasClass('has-dropdown')
      ? 'mega_menu'
      : 'nav_button';

    _rem.ascEvent('asc_menu_interaction', {
      element_text: menuText,
      element_subtype: menuSubtype,
      element_type: 'menu',
      event_action: 'click',
      product_name: 'Remora',
    });
  });

  // Tabular menu tracking (for vehicle type tabs)
  $('body').on('click', '.ui.tabular.menu .item', function () {
    const menuText = $(this).text().trim();

    _rem.ascEvent('asc_menu_interaction', {
      element_text: menuText,
      element_subtype: 'nav_tab',
      element_type: 'menu',
      event_action: 'click',
      product_name: 'Remora',
    });
  });

  // Search box interactions tracking for desktop
  $('body').on(
    'input focus',
    '.ui.website-search input, .search-widget input[type="text"], .search-form input[type="text"]',
    function (event) {
      const element = $(this);
      const elementText = element.attr('placeholder') || element.attr('aria-label') || '';
      const elementValue = element.val() || '';
      const elementType = 'search_tool';
      const elementSubtype = 'input_field';
      const eventAction = event.type === 'focus' ? 'field_input' : 'keystroke';

      _rem.ascEvent('asc_element_configuration', {
        element_text: elementText,
        element_value: elementValue,
        element_type: elementType,
        element_subtype: elementSubtype,
        element_title: elementText,
        event_action: eventAction,
        event_action_result: 'start',
        element_state: 'active',
        element_position: 'inline',
        product_name: 'Remora',
      });
    },
  );

  // Filter interactions tracking for desktop (checkboxes, radios, dropdowns, selects)
  $('body').on(
    'change click',
    'input[type="checkbox"][data-filter-key], input[type="radio"][data-filter-key], select.search-condition-select, select.search-make-select, select.search-model-select, select.min-price-select, select.max-price-select, .ui.selection.dropdown',
    function (event) {
      const element = $(this);
      const elementType = 'search_tool';
      let elementSubtype = 'dropdown';
      let eventAction = 'click';
      let elementValue = '';
      let elementText = '';
      let elementTitle = '';

      if (element.is('input[type="checkbox"], input[type="radio"]')) {
        elementSubtype = 'toggle';
        elementValue = element.is(':checked') ? element.val() : '';
        elementText = element.closest('label').find('span').text().trim() || element.val();
        elementTitle =
          element.closest('.filter_container').find('.title .text').text().trim() || 'Filter';
        eventAction = element.is(':checked') ? 'check' : 'uncheck';
      } else if (element.is('select')) {
        elementSubtype = 'dropdown';
        elementValue = element.val() || '';
        elementText =
          element.find('option:selected').text().trim() || element.attr('placeholder') || '';
        elementTitle =
          element.closest('.search-field').find('label').text().trim() ||
          element.attr('name') ||
          'Filter';
      } else if (element.hasClass('ui.selection.dropdown')) {
        elementSubtype = 'dropdown';
        elementValue = element.find('input[type="hidden"]').val() || '';
        elementText = element.find('.text').text().trim() || '';
        elementTitle = element.closest('.header.item').find('.left-label').text().trim() || 'Sort';
      }

      _rem.ascEvent('asc_element_configuration', {
        element_text: elementText,
        element_value: elementValue,
        element_type: elementType,
        element_subtype: elementSubtype,
        element_title: elementTitle,
        event_action: eventAction,
        event_action_result: 'start',
        element_state: 'active',
        element_position: 'inline',
        product_name: 'Remora',
      });
    },
  );

  // Footer navigation tracking for desktop (covers all themes)
  $('body').on('click', '.footer-nav a, .footer-nav.sub', function (event) {
    const menuText = $(this).text().trim();
    const menuSubtype = 'footer_link';

    _rem.ascEvent('asc_menu_interaction', {
      element_text: menuText,
      element_subtype: menuSubtype,
      element_type: 'menu',
      event_action: 'click',
      product_name: 'Remora',
    });
  });

  $('img.img-ll').lazyload({
    threshold: 200,
    placeholder: '//r.remorainc.com/3/images/shared/ll-loader.svg',
  });

  // Google Analytics Track (immediate)
  $('body').on('click', '.ga-t[data-label]', function () {
    const category = $(this).data('category') ? $(this).data('category') : 'button';
    const action = $(this).data('action') ? $(this).data('action') : 'click';
    const label = $(this).data('label');
    const ctaText = $(this).text().trim() || '';
    const ctaLink = $(this).attr('href') || '';

    _rem.gaEvent(category, action, label);
    _rem.ascEvent('asc_cta_interaction', { element_text: ctaText, link_url: ctaLink });
  });

  // ASC Click to Call tracking for tel: links
  $('body').on('click', 'a[href^="tel:"]', function () {
    const phoneNumber = $(this).attr('href').replace('tel:', '');
    const department = $(this).data('department') || 'unknown';

    _rem.ascEvent('asc_click_to_call', {
      comm_phone_number: phoneNumber,
      department: department,
    });
  });

  // Google Analytics Track Delayed (on the next page send it)
  $('body').on('click', '.ga-td[data-label]', function () {
    // RE-1603 (CIPA Phase 6) — no delayed-analytics cookie write while denied.
    if (!_rem.trackingPermitted()) {
      return;
    }
    const category = $(this).data('category') ? $(this).data('category') : 'button';
    const action = $(this).data('action') ? $(this).data('action') : 'click';
    const label = $(this).data('label');
    const ctaText = $(this).text().trim() || '';
    const ctaLink = $(this).attr('href') || '';

    _rem.setCookie(
      'ga-td',
      encodeURIComponent(category) +
        '!' +
        encodeURIComponent(action) +
        '!' +
        encodeURIComponent(label) +
        '!' +
        encodeURIComponent(window.location.pathname) +
        '!' +
        encodeURIComponent(window.location.href) +
        '!' +
        encodeURIComponent(document.title) +
        '!' +
        encodeURIComponent(ctaText) +
        '!' +
        encodeURIComponent(ctaLink),
      1,
    );
  });

  // On page load, get any delayed tracking events and send them to GA
  // RE-1603 (CIPA Phase 6) — no replay while denied; the storage flush
  // removes any leftover ga-td cookie.
  if (_rem.trackingPermitted() && _rem.getCookie('ga-td')) {
    const split = _rem.getCookie('ga-td').split('!');
    const category = decodeURIComponent(split[0]);
    const action = decodeURIComponent(split[1]);
    const label = decodeURIComponent(split[2]);
    const path = decodeURIComponent(split[3]);
    const fullUrl = decodeURIComponent(split[4]);
    const title = decodeURIComponent(split[5]);
    const ctaText = decodeURIComponent(split[6]);
    const ctaLink = decodeURIComponent(split[7]);

    _rem.gaEvent(category, action, label, fullUrl, title);
    _rem.ascEvent('asc_cta_interaction', { element_text: ctaText, link_url: ctaLink });
    _rem.removeCookie('ga-td');
  }

  $('select.dropdown, div.dropdown').dropdown({ forceSelection: false });
  _rem.initTooltips($);
  $('.blurring.dimmable.image').dimmer({ on: 'hover' });
  $('.drop-trigger').popup({ inline: true, hoverable: true, position: 'bottom right' });
  $('.drop-trigger-left').popup({ inline: true, hoverable: true, position: 'bottom left' });
  $('.side-drop-trigger').popup({ inline: true, hoverable: true, position: 'left center' });
  //$('.department.sidebar').first().sidebar('attach events', '#department-sidebar-toggle');
  $('.pulse-ani').transition({ animation: 'pulse' });
  $('.pulse-ani').hover(function () {
    $(this).transition('pulse');
  });
  $('#header-prop .trigger').on('click', function () {
    $('#header-prop .content').slideToggle('fast');
    $('i', this).toggleClass('up down');
  });
  $('a.blank').click(function (event) {
    event.preventDefault();
  });
  $('.tabs .item').tab({ context: 'parent' });
  _rem.initSrpTabbedPopups($);

  $.fn.search.settings.templates.category = function (response, fields) {
    let html = '';
    const escape = $.fn.search.settings.templates.escape;
    if (response[fields.categoryResults] !== undefined) {
      // each category
      $.each(response[fields.categoryResults], function (index, category) {
        if (category[fields.results] !== undefined && category.results.length > 0) {
          html +=
            '<div class="category ' +
            category[fields.categoryName].replace(' ', '-').toLowerCase() +
            '">';

          if (category[fields.categoryName] !== undefined) {
            html += '<div class="name">' + category[fields.categoryName] + '</div>';
          }

          // each item inside category
          $.each(category.results, function (index, result) {
            if (result[fields.url]) {
              html += '<a class="result" href="' + result[fields.url] + '">';
            } else {
              html += '<a class="result">';
            }
            if (result[fields.image] !== undefined) {
              html +=
                '' + '<div class="image">' + ' <img src="' + result[fields.image] + '">' + '</div>';
            }
            html += '<div class="content">';
            if (result[fields.price] !== undefined) {
              html += '<div class="price">' + result[fields.price] + '</div>';
            }
            if (result[fields.title] !== undefined) {
              html += '<div class="title">' + result[fields.title] + '</div>';
            }
            if (result[fields.description] !== undefined) {
              html += '<div class="description">' + result[fields.description] + '</div>';
            }
            html += '' + '</div>';
            html += '</a>';
          });
          html += '' + '</div>';
        }
      });
      if (response[fields.action]) {
        html +=
          '' +
          '<a href="' +
          response[fields.action][fields.actionURL] +
          '" class="action">' +
          response[fields.action][fields.actionText] +
          '</a>';
      }
      return html;
    }
    return false;
  };

  $('.ui.website.search').search({
    apiSettings: {
      url: '/search.json?q={query}&type={type}',
      beforeSend: function (settings) {
        const typeRadio = $(this).parent().find('input[name=type]:checked');
        settings.urlData.type = typeRadio.length ? typeRadio.val() : '';
        return settings;
      },
    },
    type: 'category',
    cache: false,
    selectFirstResult: true,
    searchDelay: 250,
  });

  $('.counter').each(function () {
    const $this = $(this),
      countTo = $this.attr('data-count');

    $({ countNum: $this.text() }).animate(
      {
        countNum: countTo,
      },

      {
        duration: 4000,
        easing: 'linear',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
          //alert('finished');
        },
      },
    );
  });

  if (typeof $().succinct === 'function') {
    $('.truncate_75').succinct({ size: 75 });
  }

  if (typeof $().calendar === 'function') {
    $('.ui.calendar').calendar();
  }

  if (typeof $().tab === 'function') {
    $('.tabular.menu .item').tab();
  }

  //Smooth Scroll
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        let target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
          );
        } else {
          // Prevent default behavior if target doesn't exist to avoid redirects
          event.preventDefault();
        }
      }
    });

  // Vehicle image gallery tracking for desktop
  // Track gallery open event when clicking to open gallery
  let galleryOpenEventFired = false;
  $('body').on('click', '.image-container, #vehicleImagesBox', function (event) {
    if (!galleryOpenEventFired) {
      _rem.ascEvent('asc_media_interaction', {
        page_type: 'item',
        event_action: 'click',
        event_action_result: 'open',
        media_type: 'gallery',
        link_url: window.location.href,
        product_name: 'Remora',
      });
      galleryOpenEventFired = true;
    }
  });

  // Gallery modal scroll tracking for desktop
  let galleryScrollHandler = null;
  const galleryScrollEvents = {
    scrollFired: false,
    fiftyPercentFired: false,
    hundredPercentFired: false,
  };

  // Listen for modal show event (Semantic UI)
  $('body').on('modal:show', '#galleryModal', function (event) {
    setupGalleryScrollTracking($(this));
  });

  // Fallback: Also listen for when modal becomes visible
  function setupGalleryScrollTracking($modal) {
    // Reset scroll tracking state
    galleryScrollEvents.scrollFired = false;
    galleryScrollEvents.fiftyPercentFired = false;
    galleryScrollEvents.hundredPercentFired = false;

    // Remove any existing scroll handler
    if (galleryScrollHandler) {
      const $dimmer = $('.ui.dimmer.modals.page, .ui.dimmer.modals, .ui.modals.dimmer');
      $dimmer.off('scroll', galleryScrollHandler);
      $(window).off('scroll', galleryScrollHandler);
    }

    // Set up scroll tracking - use setTimeout to ensure modal is fully rendered
    setTimeout(function () {
      // Create scroll handler
      galleryScrollHandler = function (event) {
        let scrollTop, scrollHeight, clientHeight;

        // Check Semantic UI dimmer first (primary scroll source for modals)
        const $dimmer = $('.ui.dimmer.modals.page, .ui.dimmer.modals, .ui.modals.dimmer').filter(
          ':visible',
        );

        if ($dimmer.length && $dimmer[0].scrollHeight > $dimmer[0].clientHeight) {
          scrollTop = $dimmer.scrollTop();
          scrollHeight = $dimmer[0].scrollHeight;
          clientHeight = $dimmer[0].clientHeight;
        } else {
          // Fallback to window scroll
          scrollTop = $(window).scrollTop();
          scrollHeight = $(document).height();
          clientHeight = $(window).height();
        }

        const result = _rem.gallery.computeScrollEvents(
          galleryScrollEvents,
          scrollTop,
          scrollHeight,
          clientHeight,
          window.location.href,
        );

        for (let i = 0; i < result.events.length; i++) {
          _rem.ascEvent(result.events[i].name, result.events[i].params);
        }

        galleryScrollEvents.scrollFired = result.newState.scrollFired;
        galleryScrollEvents.fiftyPercentFired = result.newState.fiftyPercentFired;
        galleryScrollEvents.hundredPercentFired = result.newState.hundredPercentFired;
      };

      // Attach scroll handler to dimmer (primary) and window (fallback)
      const $dimmer = $('.ui.dimmer.modals.page, .ui.dimmer.modals, .ui.modals.dimmer').filter(
        ':visible',
      );

      if ($dimmer.length) {
        $dimmer.on('scroll', galleryScrollHandler);
      }

      $(window).on('scroll', galleryScrollHandler);
    }, 100);
  }

  // Fallback: Check if modal is visible and set up tracking
  const checkGalleryModal = setInterval(function () {
    const $modal = $('#galleryModal');
    if (
      $modal.length &&
      $modal.hasClass('visible') &&
      $modal.hasClass('active') &&
      !galleryScrollHandler
    ) {
      setupGalleryScrollTracking($modal);
    }
  }, 500);

  // Clean up interval when page unloads
  $(window).on('beforeunload', function () {
    clearInterval(checkGalleryModal);
  });

  // Clean up scroll handler when modal closes
  $('body').on('modal:hide', '#galleryModal', function (event) {
    if (galleryScrollHandler) {
      const $dimmer = $('.ui.dimmer.modals.page, .ui.dimmer.modals, .ui.modals.dimmer');
      $dimmer.off('scroll', galleryScrollHandler);
      $(window).off('scroll', galleryScrollHandler);
      galleryScrollHandler = null;
    }

    // Reset gallery open event flag when modal closes
    galleryOpenEventFired = false;
  });

  // Vehicle carousel image tracking for desktop
  $('body').on('click', '.inv-carousel .img-cont-wrapper a', function (event) {
    const element = $(this);
    const vehicleImage = element.find('img');
    const vehicleLink = element.attr('href') || '';
    const imageAlt = vehicleImage.attr('alt') || '';

    _rem.ascEvent('asc_media_interaction', {
      event_action: 'click',
      event_action_result: 'redirect',
      media_type: 'image',
      creative_name: imageAlt,
      link_url: vehicleLink,
      product_name: 'Remora',
    });
  });

  // Video play button tracking for desktop
  $('body').on('click', '.video-btn', function (event) {
    const element = $(this);
    const videoLink = element.attr('href') || '';
    const videoImage = element.find('img');
    const videoAlt = videoImage.attr('alt') || 'Play Video';

    _rem.ascEvent('asc_media_interaction', {
      event_action: 'click',
      event_action_result: 'play',
      media_type: 'video',
      creative_name: videoAlt,
      link_url: videoLink,
      product_name: 'Remora',
    });
  });

  // Carousel/slider navigation tracking for desktop
  $('body').on('click', '.carousel-controls button, .home-prev, .home-next', function (event) {
    const element = $(this);
    const isNext = element.hasClass('next') || element.find('.angle.right').length > 0;
    const isPrev = element.hasClass('prev') || element.find('.angle.left').length > 0;
    const action = isNext ? 'next' : isPrev ? 'prev' : 'click';

    _rem.ascEvent('asc_media_interaction', {
      event_action: 'click',
      event_action_result: action,
      media_type: 'slider',
      creative_name: 'Carousel Navigation',
      product_name: 'Remora',
    });
  });

  // Article carousel image tracking for desktop
  $('body').on('click', '.articles .card .image a', function (event) {
    const element = $(this);
    const articleImage = element.find('img');
    const articleLink = element.attr('href') || '';
    const imageAlt = articleImage.attr('alt') || '';
    const articleTitle = element.closest('.card').find('.title').text().trim() || '';

    _rem.ascEvent('asc_media_interaction', {
      event_action: 'click',
      event_action_result: 'redirect',
      media_type: 'image',
      creative_name: articleTitle || imageAlt,
      link_url: articleLink,
      product_name: 'Remora',
    });
  });

  // Keen slider thumbnail tracking for desktop (Hillnew theme)
  $('body').on('click', '.keen-slider__slide img', function (event) {
    const element = $(this);
    const imageAlt = element.attr('alt') || '';

    _rem.ascEvent('asc_media_interaction', {
      event_action: 'click',
      event_action_result: 'view',
      media_type: 'image',
      creative_name: imageAlt,
      product_name: 'Remora',
    });
  });

  // Special offer tracking for desktop - Pop-ups and modals
  $('body').on('modal:show', '.ui.pop-up.modal', function (event) {
    const element = $(this);
    const promotionName =
      element.attr('data-popup_name') || element.find('.header').text().trim() || 'Special Offer';
    const elementPosition = 'floating';
    const department = 'sales'; // Default to sales for special offers

    // RE-2274: the Matomo label carries the popup_view| marker so the Traffic
    // Report can tell a popup view from a click; the ASC parameters are unchanged.
    _rem.ascEvent(
      'asc_special_offer',
      {
        promotion_name: promotionName,
        department: department,
        element_position: elementPosition,
        flow_outcome: 'viewed',
        product_name: 'Remora',
      },
      'popup_view|' + promotionName,
    );
  });

  // Special offer tracking for desktop - Cookie banner
  // Check if banner is visible when page loads (banner visibility is controlled by cookie_banner.blade.php)
  const cookieBanner = document.getElementById('cookie-consent-banner');
  if (cookieBanner && cookieBanner.style.display !== 'none') {
    _rem.ascEvent('asc_special_offer', {
      promotion_name: 'Cookie Consent',
      department: 'admin',
      element_position: 'bottom_center',
      flow_outcome: 'viewed',
      product_name: 'Remora',
    });

    // RE-2274: the legacy notice is actually displayed here (no stored
    // acknowledgement), so record it for the Traffic Report's cookie card.
    _rem.emitLegacyNoticeEvent('privacy_banner_shown', true);

    $('body').on('click', '#cookie-close', function () {
      _rem.emitLegacyNoticeEvent('privacy_banner_dismissed');
    });
  }

  // Special offer tracking for desktop - Toolbar
  $('body').on('click', '#info_cls', function (event) {
    const toolbar = $('#info_bar_open');
    if (toolbar.is(':visible')) {
      _rem.ascEvent('asc_special_offer', {
        promotion_name: 'Information Toolbar',
        department: 'admin',
        element_position: 'bottom_center',
        flow_outcome: 'viewed',
        product_name: 'Remora',
      });
    }
  });

  // Special offer tracking for desktop - Off-canvas sidebars
  $('body').on(
    'click',
    '.launch-dept-oc, .launch-nav-oc, .launch-acct-oc, .launch-search-oc, .launch-form-oc, .launch-vehicle-quickview-oc',
    function (event) {
      const element = $(this);
      const sidebarType = element.attr('class').match(/launch-(\w+)-oc/);
      const promotionName = sidebarType
        ? sidebarType[1].replace('_', ' ').toUpperCase() + ' Sidebar'
        : 'Sidebar';
      const elementPosition = 'center_right';

      _rem.ascEvent('asc_special_offer', {
        promotion_name: promotionName,
        department: 'admin',
        element_position: elementPosition,
        flow_outcome: 'viewed',
        product_name: 'Remora',
      });
    },
  );

  // Special offer tracking for desktop - Side buttons (popup triggers)
  $('body').on('click', '.popup-trigger.popup-side-button', function (event) {
    const element = $(this);
    const promotionName = element.text().trim() || 'Special Offer Button';
    const elementPosition = element.hasClass('popup-side-button-left')
      ? 'center_left'
      : element.hasClass('popup-side-button-right')
        ? 'center_right'
        : 'floating';

    _rem.ascEvent('asc_special_offer', {
      promotion_name: promotionName,
      department: 'sales',
      element_position: elementPosition,
      flow_outcome: 'viewed',
      product_name: 'Remora',
    });
  });

  // Initialize event delegation using vanilla JS - runs once, handles all current and added later buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.button--payment-calculator, .button--value-your-trade');
    if (btn) {
      e.preventDefault();
      const isValueYourTrade = btn.classList.contains('button--value-your-trade');
      _rem.handleEnhancedPaymentsButtonClick(btn, isValueYourTrade);
    }
  });

  // Preload Payment Calculator partial on CTA button mousover - using vanilla JS syntax
  document.addEventListener(
    'mouseover',
    function (e) {
      if (e.target.closest('.button--payment-calculator, .button--value-your-trade')) {
        _rem.preloadPaymentCalculator(); // Fetch but don't open
      }
    },
    { passive: true },
  );
};
//});

// Disclaimer tooltips nested inside a container: the SRP tabbed incentive
// popup, the pricing detail modal and the Quick View panel. inline keeps each
// popup inside its container, so a container with a raised z-index cannot bury
// it, and boundary fit-tests against the container instead of the window.
// Markup often sets data-position, which beats settings.position, so it is
// stripped from both the attribute and jQuery's data cache. Semantic abandons a
// popup when no placement passes the fit test, which a long disclaimer
// guarantees; lastResort forces a placement instead. hoverable keeps the popup
// open while the pointer is on it, so the capped, scrolling
// pricing-disclaimer-tooltip area can be read (RE-1807, RE-1770, RE-2464).
// placement carries position, maxSearchDepth and lastResort.
_rem.initContainedTooltips = function ($tooltips, $boundary, placement) {
  $tooltips.removeAttr('data-position').removeData('position');
  $tooltips.popup({
    inline: true,
    boundary: $boundary,
    position: placement.position,
    maxSearchDepth: placement.maxSearchDepth,
    lastResort: placement.lastResort,
    hoverable: true,
    className: {
      popup: 'ui popup pricing-disclaimer-tooltip',
    },
  });
};

_rem.initSrpTabbedPopups = function ($) {
  $('.list-item-incentive-popup-trigger').each(function () {
    var $trigger = $(this);
    if ($trigger.data('popupBound')) {
      return;
    }
    $trigger.data('popupBound', true);
    var vid = $trigger.data('vehicle-id');
    var $content = $('#list-item-incentive-popup-' + vid);
    var pinned = false;
    var hideTimer = null;
    var scheduleHide = function () {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (!pinned) {
          $trigger.popup('hide');
        }
      }, 120);
    };

    $trigger.popup({
      on: 'manual',
      html: $content.html(),
      position: 'top center',
      // RE-1807: same cannotPlace exposure as the nested tooltips if this
      // outer popup's content grows tall; keep preferred top-center placement.
      lastResort: 'top center',
      hoverable: true,
      onShow: function () {
        var $popup = $(this);
        // RE-1807 Surface 2: nested disclaimer tooltips (SRP/VDP/off-canvas
        // Additional Incentives), contained by the outer incentive popup.
        // Same placement as initPricingDetailPopups: always below the trigger.
        _rem.initContainedTooltips($popup.find('.tooltip'), $popup, {
          position: 'bottom left',
          maxSearchDepth: 0,
          lastResort: 'bottom left',
        });
        $popup
          .find('.list-item-incentive-popup-close')
          .off('click.rePopupClose')
          .on('click.rePopupClose', function (e) {
            e.stopPropagation();
            pinned = false;
            $trigger.popup('hide');
          });
        $popup
          .off('mouseenter.rePopup mouseleave.rePopup')
          .on('mouseenter.rePopup', function () {
            clearTimeout(hideTimer);
          })
          .on('mouseleave.rePopup', scheduleHide);
      },
      onHide: function () {
        pinned = false;
      },
    });

    $trigger.on('mouseenter.rePopup', function () {
      clearTimeout(hideTimer);
      $trigger.popup('show');
    });
    $trigger.on('mouseleave.rePopup', scheduleHide);
    $trigger.on('click.rePopup', function (e) {
      e.preventDefault();
      e.stopPropagation();
      pinned = true;
      clearTimeout(hideTimer);
      $trigger.popup('show');
    });
  });

  if (!$(document).data('rePopupOutsideBound')) {
    $(document).data('rePopupOutsideBound', true);
    $(document).on('click.rePopupOutside', function (e) {
      if ($(e.target).closest('.list-item-incentive-popup-trigger, .ui.popup').length) {
        return;
      }
      $('.list-item-incentive-popup-trigger').each(function () {
        $(this).popup('hide');
      });
    });
  }
};

// RE-1387: bind the "View Pricing Detail" triggers to their Semantic UI
// modals. Idempotent per trigger (data-guard) and safe to re-run after
// AJAX list redraws, mirroring initSrpTabbedPopups.
// Known edge case (RE-1387, low severity): Semantic modals are detachable, so
// an opened popup is moved to a body-level dimmer. If a shopper has a popup open
// when the SRP does an AJAX redraw, that modal can be left orphaned in <body>.
// Not handled here; requires modal-open + redraw simultaneously.
_rem.initPricingDetailPopups = function ($) {
  $('.pricing-detail-trigger').each(function () {
    var $trigger = $(this);
    if ($trigger.data('pricingDetailBound')) {
      return;
    }
    $trigger.data('pricingDetailBound', true);
    var vid = $trigger.data('vehicle-id');
    var $modal = $('#pricing-detail-modal-' + vid);
    if (!$modal.length) {
      return;
    }
    $modal.modal({
      closable: true,
      blurring: false,
      observeChanges: false,
      onVisible: function () {
        // Every modal tooltip opens below its trigger: maxSearchDepth: 0
        // skips Semantic's flip-to-top search and lastResort pins bottom left
        // (RE-1807).
        _rem.initContainedTooltips($modal.find('.tooltip'), $modal, {
          position: 'bottom left',
          maxSearchDepth: 0,
          lastResort: 'bottom left',
        });
      },
    });
    $trigger.on('click', function (e) {
      e.preventDefault();
      $modal.modal('show');
    });
  });
};

// RE-1818: bare .popup() abandons tall tooltips (cannotPlace). lastResort
// forces a visible placement site-wide for every .tooltip that no other
// initialiser rebinds (SRP card pricing rows and the rest of the site).
_rem.initSitewideTooltips = function ($, root) {
  $('.tooltip', root).popup({
    lastResort: 'bottom left',
  });
};

// RE-1818: pricing disclaimer tooltips on SRP cards and VDP price blocks.
// Rebinds that subset with the shared scroll/hover contract so a tall
// disclaimer stays readable, without applying hoverable / scroll CSS to every
// .tooltip on the site.
_rem.initPricingDisclaimerTooltips = function ($, root) {
  var $tooltips = $(
    '.srp-detailed-pricing-block .tooltip, .srp-tabs .ui.tab .tooltip, .veh-price-block .tooltip',
    root,
  );
  if (!$tooltips.length) {
    return;
  }
  $tooltips.popup({
    lastResort: 'bottom left',
    hoverable: true,
    className: {
      popup: 'ui popup pricing-disclaimer-tooltip',
    },
  });
};

// RE-1818: the single entry point for tooltip binding. The pricing pass must
// run after the generic one: re-initialising with an options object destroys
// the earlier instance and rebuilds it from the later call's settings alone, so
// the order is the whole two-tier design. Keeping it here keeps it out of every
// caller.
//
// `root` confines both passes to one container, so a partial refresh cannot
// rebind a tooltip outside the markup it replaced. Page load passes no root and
// binds the document, before the Quick View panel has content. The panel's
// tooltips are bound by _rem.initQuickviewTooltips, and a later binding
// replaces their settings, so no root passed here may contain
// #vehicle-quickview-oc.
_rem.initTooltips = function ($, root) {
  _rem.initSitewideTooltips($, root);
  _rem.initPricingDisclaimerTooltips($, root);
};

// RE-1770: Quick View tooltips, contained by the panel, so a domain's custom
// CSS that raises the panel's z-index cannot bury them. Most triggers sit at
// the left edge of their row; the finance and lease trigger sits inside the
// price amount, nearer the middle. Left-aligned placements grow rightward into
// the panel from either, so the markup's top center and left center are
// replaced. maxSearchDepth: 1 tries top left, then forces bottom left.
// lastResort reuses the offset of the position it replaces, so a deeper search
// would place bottom left with left center's offset, away from the icon.
_rem.initQuickviewTooltips = function ($, $panel) {
  if (!$panel || !$panel.length) {
    return;
  }
  _rem.initContainedTooltips($panel.find('.tooltip'), $panel, {
    position: 'top left',
    maxSearchDepth: 1,
    lastResort: 'bottom left',
  });
};

function googleTranslateElementInit() {
  new google.translate.TranslateElement(
    { pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE },
    'google_translate_element',
  );
}

_rem.fileEnd();
